'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = {
    isFunc: function isFunc(arg) {
        return 'function' == typeof arg;
    },
    isObj: function isObj(arg) {
        return arg && 'object' == (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) && !(arg instanceof Array);
    },
    isSimple: function isSimple(arg) {
        var type = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);
        return type == 'string' || type == 'number' || type == 'boolean';
    },
    isFlatObj: function isFlatObj(arg) {
        if (this.isObj(arg)) {
            for (var key in arg) {
                if (arg.hasOwnProperty(key) && !this.isSimple(arg[key])) {
                    return false;
                }
            }
            return true;
        }
        return false;
    }
};